import Navbar from "../components/Navbar";

function Booking() {
  return (
    <div>
      <Navbar />

      <div style={{ padding: "40px" }}>
        <h1>Booking Page</h1>
      </div>
    </div>
  );
}

export default Booking;